import React from 'react';
import { LineChart, Legend, CartesianGrid, XAxis, ComposedChart, Line, Bar, Tooltip, YAxis } from 'recharts';

type Props = {
  record: any
};

const ResultsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    {props.record.histories && props.record.histories['global'] &&
      <span>
        <h4>Global Count</h4>
        <LineChart
          width={500}
          height={300}
          data={props.record.histories && props.record.histories['global']}
          margin={{
            top: 5, right: 30, left: 20, bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="actual" stroke="#8884d8" activeDot={{ r: 8 }} />
          <Line type="monotone" dataKey="min" stroke="#E96A8D" />
          <Line type="monotone" dataKey="max" stroke="#872E92" />
        </LineChart> <br /> <br />
      </span>
    }

    {
      props.record.histories && props.record.histories['checks'] && Object.entries(props.record.histories['checks']).map((item, index) => (
        <div key={index}>
          <h4>{item[0]} Checks</h4>
          <LineChart
            width={500}
            height={300}
            data={item[1]}
            margin={{
              top: 5, right: 30, left: 20, bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="actual" stroke="#8884d8" activeDot={{ r: 8 }} />
            <Line type="monotone" dataKey="expected" stroke="#82ca9d" activeDot={{ r: 0 }} />
            <Line type="monotone" dataKey="max" stroke="#82ca9d" activeDot={{ r: 0 }} />
            <Line type="monotone" dataKey="min" stroke="#82ca9d" activeDot={{ r: 0 }} />
          </LineChart> <br /> <br />
        </div >
      ))
    }

  </div>
);

export default ResultsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/ResultsTab.tsx